import { SET_PRINT_INSTRUCTIONS_EXPANDED, SET_PRINT_INSTRUCTIONS, RESET_PRINT_INSTRUCTIONS } from '@app/actions/_types';

export const setPrintInstructionsExpanded = expanded => ({
  type: SET_PRINT_INSTRUCTIONS_EXPANDED,
  payload: expanded,
});

export const setPrintInstructions = printInstructions => ({
  type: SET_PRINT_INSTRUCTIONS,
  payload: printInstructions,
});

export const resetPrintInstructions = () => ({
  type: RESET_PRINT_INSTRUCTIONS,
});
